import { useTranslation } from 'react-i18next';
import CommonSetErrorType from '../../../../CommonSetError.type';
import { useCommonErrorHandler } from '../../../../useErrorHandler';

const useNylasAccountNotAuthorizedErrorHandler = (setError?: CommonSetErrorType) => {
  const { t } = useTranslation();

  const { handler } = useCommonErrorHandler({
    setError,
    errorCode: 'NYLAS_ACCOUNT_NOT_AUTHORIZED',
    errorMessage: t(
      'pluginSettings.sections.uploadHub.subsections.synchronizedInboxes.controls.errors.nylasNotAuthorized',
    ),
  });

  return handler;
};

export default useNylasAccountNotAuthorizedErrorHandler;
